/* Local Storage */
export const LS_ACCESS_TOKEN = "ms_access_token";
